<template>
  <v-form>
    <px-view-header title="Solicitar confirmação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div class="mt-3" v-if="!loading && !loadingCampoPersonalizado">
      <!--          Dados gerais-->
      <v-row>
        <v-col cols="12">
          <span class="headline font-weight-bold title">
            Detalhamento do pedido
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-truck-outline
            </v-icon>
            <span class="ml-2">Frete</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="5">
          <px-autocomplete-transportadora
            dense
            :class="`rounded-tag-small ${isTransportadoraRequired ? 'required' : ''}`"
            search-by-code
            :error="$v.finalizacao.transportadora.$error"
            @blur="$v.finalizacao.transportadora.$touch()"
            v-model="finalizacao.transportadora"/>
        </v-col>
        <v-col cols="12" sm="2">
          <px-select-enum dense
                          label="Tipo de frete"
                          class="required rounded-tag-small"
                          :error="$v.finalizacao.frete.tipoFrete.$error"
                          @blur="$v.finalizacao.frete.tipoFrete.$touch()"
                          v-model="finalizacao.frete.tipoFrete"
                          @change="onChangeTipoFrete"
                          :items="tiposFretes"/>
        </v-col>
        <v-col cols="12" sm="2">
          <px-input-currency
            dense
            label="Valor do Frete"
            class="rounded-tag-small"
            :options="configuracaoMoeda"
            v-model="finalizacao.frete.totalTransporte"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-date-picker dense
                          label="Prazo de entrega solicitado"
                          input-class="required rounded-tag-small"
                          :error="$v.finalizacao.dataPrevisaoEntrega.$error"
                          @blur="$v.finalizacao.dataPrevisaoEntrega.$touch()"
                          v-model="finalizacao.dataPrevisaoEntrega"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-autocomplete-locais-entrega
            dense
            required
            class="required rounded-tag-small"
            :error="$v.finalizacao.locaisEntrega.$error"
            @blur="$v.finalizacao.locaisEntrega.$touch()"
            v-model="finalizacao.locaisEntrega"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-currency-usd
            </v-icon>
            <span class="ml-2">Faturamento</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3">
          <px-select-enum
            dense
            label="Forma de pagamento"
            class="required rounded-tag-small"
            v-model="finalizacao.formaPagamento"
            :error="$v.finalizacao.formaPagamento.$error"
            @blur="$v.finalizacao.formaPagamento.$touch()"
            :items="formasPagamentos"
            @change="onChangeFormaPagamento"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <px-autocomplete-prazo-pagamento
            dense
            label="Prazo de pagamento"
            :class="isAVista ? 'rounded-tag-small' : 'required rounded-tag-small'"
            :disabled="isAVista"
            :error="$v.finalizacao.prazoPagamento.$error"
            @blur="$v.finalizacao.prazoPagamento.$touch()"
            v-model="finalizacao.prazoPagamento"/>
        </v-col>
        <v-col cols="12" :sm="smModoPagamento">
          <px-autocomplete-modo-de-pagamento
            dense
            :class="`rounded-tag-small ${isModoPagamentoRequired ? 'required' : ''}`"
            :error="$v.finalizacao.modoPagamento.$error"
            @blur="$v.finalizacao.modoPagamento.$touch()"
            v-model="finalizacao.modoPagamento"/>
        </v-col>
        <v-col cols="12" sm="3" v-if="hasDataNecessidadeEntregaSolicitacao">
          <px-date-picker dense
                          label="Data de entrega solicitante"
                          input-class="rounded-tag-small"
                          v-model="finalizacao.dataNecessidadeEntregaSolicitacao"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="5">
          <px-autocomplete-comprador
            dense
            required
            label="Local de faturamento"
            class="required rounded-tag-small"
            :error="$v.finalizacao.comprador.$error"
            @blur="$v.finalizacao.comprador.$touch()"
            v-model="finalizacao.comprador"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-autocomplete-nota-entrada
            dense
            :class="`rounded-tag-small ${isTipoNotaEntradaRequired ? 'required' : ''}`"
            :error="$v.finalizacao.tipoNotaEntrada.$error"
            @blur="$v.finalizacao.tipoNotaEntrada.$touch()"
            v-model="finalizacao.tipoNotaEntrada"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-date-picker dense
                          label="Data de Faturamento"
                          input-class="required rounded-tag-small"
                          :error="$v.finalizacao.dataFaturamento.$error"
                          @blur="$v.finalizacao.dataFaturamento.$touch()"
                          v-model="finalizacao.dataFaturamento"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-text-box-outline
            </v-icon>
            <span class="ml-2">Dados gerais</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-projeto
            dense
            :disabled="isProjetoReadonly"
            :class="`rounded-tag-small ${isProjetoRequired ? 'required' : ''}`"
            :error="$v.finalizacao.projeto.$error"
            @blur="$v.finalizacao.projeto.$touch()"
            v-model="finalizacao.projeto"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-centro-custo
            dense
            :disabled="isCentroCustoReadonly"
            :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
            :error="$v.finalizacao.centroCusto.$error"
            @blur="$v.finalizacao.centroCusto.$touch()"
            v-model="finalizacao.centroCusto"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            v-model="finalizacao.observacao"
            label="Observações internas"
            counter="1000"
            rows="2"/>
        </v-col>
      </v-row>
      <v-row dense v-if="showNotificaFornecedor">
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-bell-ring
            </v-icon>
            <span class="ml-2">Notificação para o fornecedor</span>
          </v-subheader>
        </v-col>
        <v-col cols="12">
          <v-checkbox v-model="finalizacao.notificaFornecedor"
                      color="primary"
                      @change="onChangeCheckNotificaFornecedor">
            <template v-slot:label>
              <div class="text--primary">
                Solicitar confirmação da compra e notificar fornecedor
              </div>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            v-model="finalizacao.mensagem"
            :disabled="!finalizacao.notificaFornecedor"
            label="Mensagem para o fornecedor"
            counter="1000"
            rows="2">
            <template v-slot:append-outer>
              <px-anexo v-if="!isAprovacaoEnabled"
                        v-model="finalizacao.arquivos"
                        :max="3"
                        @loading="onFileLoad">
                <template v-slot:activator="{ on }">
                  <v-btn x-small class="normal-btn-text elevation-0"
                         color="primary" v-on="on">
                    Anexos
                  </v-btn>
                </template>
              </px-anexo>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-comment-processing-outline
            </v-icon>
            <span class="ml-2">Mensagens personalizadas</span>
          </v-subheader>
        </v-col>
      </v-row>
      <px-finalizacao-cadastro-mensagens-personalizadas
        :finalizacao="finalizacao"
        @remove="onRemoveMessage"/>
      <v-row dense v-if="erpCamposIntegracao && hasFields">
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-progress-wrench
            </v-icon>
            <span class="ml-2">Campos de integração</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense v-if="erpCamposIntegracao && hasFields">
        <v-col cols="12">
          <px-campos-integracao type="compra"
                                dense
                                :form-data="cadastrosAdicionais"/>
        </v-col>
      </v-row>
      <!--      produtos-->
      <v-row>
        <v-col cols="12">
          <span class="headline font-weight-bold title">Produtos</span>
        </v-col>
      </v-row>
      <v-row dense>
        <v-expansion-panels class="rounded-card" multiple focusable
                            v-model="expandedPanels"
                            v-if="produtos && produtos.length">
          <v-expansion-panel
            active-class="rounded-card"
            v-for="(produto, index) in produtos"
            :key="produto.id"
          >
            <v-expansion-panel-header>
              <px-finalizacao-produto-panel-header ref="productHeader"
                                                   :produto="produto"
                                                   :campos-obrigatorios="camposObrigatorios"
                                                   :moeda="moeda"/>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <px-finalizacao-produto-panel-content
                ref="productContent"
                :erp-campos-integracao="erpCamposIntegracao"
                :campos-obrigatorios="camposObrigatorios"
                :campos-readonly="camposReadonly"
                :campos-hidden="camposHidden"
                :has-any-item-from-requisicao="hasAnyItemFromRequisicao"
                :produto="produto"
                @invalid="onProductContextInvalid(index)"
                @replicar-campo="onReplicarCampo"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row dense class="mt-2 mb-2">
        <v-col cols="12" v-if="isMoedaEstrangeira">
          <px-moeda-chip :moeda="moeda"/>
        </v-col>
        <v-col cols="12" sm="4">
          <template v-if="isMoedaEstrangeira">
            <v-row dense no-gutters class="body-1">
              <v-col cols="6">
                Produtos:
              </v-col>
              <v-col cols="6" class="text-right">
                {{ totaisCompra.totalProdutos |
                      currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
              </v-col>
              <v-col cols="6">
                Frete:
              </v-col>
              <v-col cols="6" class="text-right">
                {{ totaisTransporte.totalTransporte |
                      currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)}}
              </v-col>
              <v-col cols="6" class="font-weight-bold">
                Total:
              </v-col>
              <v-col cols="6" class="text--primary--color font-weight-bold text-right">
                {{ totaisCompra.total |
                      currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
              </v-col>
              <template v-if="totaisSaving.saving > 0">
                <v-col cols="6" class="font-weight-bold">
                  Saving:
                </v-col>
                <v-col cols="6" class="text--success--color font-weight-bold text-right">
                  {{
                    totaisSaving.saving |
                      currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                  }}
                </v-col>
              </template>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="4">
        </v-col>
        <v-col cols="12" sm="4">
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ totaisCompra.totalProdutosConvertido | currency('R$', casaDecimal) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ totaisTransporte.totalTransporteConvertido | currency('R$', 2) }}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text--primary--color font-weight-bold text-right">
              {{ totaisCompra.totalConvertido | currency('R$', casaDecimal) }}
            </v-col>
            <template v-if="totaisSaving.savingConvertido > 0">
              <v-col cols="6" class="font-weight-bold">
                Saving:
              </v-col>
              <v-col cols="6" class="text--success--color font-weight-bold text-right">
                {{ totaisSaving.savingConvertido | currency('R$', 2) }}
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <div class="d-flex justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn color="primary"
                     class="rounded-tag-small elevation-0 normal-btn-text"
                     @click.stop="finalizar">
                <span v-if="isAprovacaoEnabled">
                  Solicitar confirmação
                </span>
                <span v-else>
                  Enviar ordem de compra
                </span>
              </v-btn>
            </span>
          </template>
          <span v-if="isAprovacaoEnabled">
            Solicitar confirmação das informaçoes para o fornecedor
          </span>
          <span v-else>
            Enviar ordem de compra para fornecedor
          </span>
        </v-tooltip>
      </div>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  flatten,
  some,
} from 'lodash';
import { FormaPagamento, TipoFrete } from 'px-business-components';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { GET_ITENS } from '@/store/carrinho/actions.type';
import validationMixin from '@/mixins/validation-mixin';
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';
import moment from 'moment';
import { formatToCode } from '@/utils/moment-date-utils';
import FinalizacaoProdutoPanelHeader
  from '@/modules/carrinho/finalizacao/finalizacao-produtos/FinalizacaoProdutoPanelHeader.vue';
import FinalizacaoProdutoPanelContent
  from '@/modules/carrinho/finalizacao/finalizacao-produtos/FinalizacaoProdutoPanelContent.vue';
import {
  computeFromProduto,
  validateCamposProdutoErp,
} from '@/modules/produtos/campos-erp/helpers/validate-campos-erp';
import moedaMixin from '@/mixins/moeda-mixin';
import EntidadeCamposCompraService
  from '@/modules/erp-campos/entidade-campos-compra-service';
import {
  isFieldRequiredEntity,
  isFieldReadonlyEntity,
} from '@/modules/erp-campos/erp-campos-utils';
import { CasaDecimalUtils } from 'px-components';
import { isSameDate, isDateAfterOrSameToday, getValidDate } from '@/utils/date-utils';
import { buildFornecedor } from '@/utils/fornecedor-utils';
import { replicarCampoProdutos, mergeCadastrosAdicionais, buildCadastrosAdicionaisPayload } from '@/utils/cadastros-adicionais-utils';
import TiposEntidadeCadastroAdicional from '@/enums/tipos-entidade-cadastro-adicional';
import EntidadeCamposPersonalizadosService from '@/modules/campos-personalizados/entidade-campos-personalizados-service';
import { setCamposPersonalizados } from '@/modules/campos-personalizados/campos-personalizado-utils';
import MoedaService from '@/api/valor-moeda-service';
import { calcularSavingFinalizacao } from './calculo-finalizacao.service';
import { calcularTotaisCompra, calcularTotaisTransporte } from '../../compra/cadastro/calculo-compra.service';
import CarrinhoService from '../carrinho-service';
import {
  getObservacaoFrete,
  getPrazoEntrega,
  getTipoFrete,
  getValorFrete,
  getValorFreteConvertido,
  solicitaFormaPagamento,
} from './finalizacao-utils';
import {
  computeFrom,
  initialStateCamposErp,
  validateCamposErp,
} from './campos-erp/validate-campos-erp';
import FinalizacaoCadastroMensagensPersonalizadas
  from './FinalizacaoCadastroMensagensPersonalizadas.vue';
import TipoNotaEntradaService from '../../tipo-nota-entrada/tipo-nota-entrada-service';

export default {
  name: 'Finalizacao',
  mixins: [validationMixin, moedaMixin],
  data() {
    return {
      cadastrosAdicionais: null,
      camposObrigatorios: null,
      camposReadonly: null,
      camposHidden: null,
      camposPersonalizados: null,
      taxaVenda: null,
      loadingCampoPersonalizado: false,
      hasFileLoading: false,
      expandedPanels: [],
      idsProdutos: [],
      loading: false,
      carrinhos: [],
      produtos: [],
      tiposFretes: TipoFrete.values,
      formasPagamentos: FormaPagamento.values,
      solicitaFormaPagamento: null,
      finalizacao: {
        comprador: null,
        locaisEntrega: null,
        transportadora: null,
        observacao: null,
        mensagem: null,
        notificaFornecedor: true,
        dataFaturamento: formatToCode(moment()),
        dataPrevisaoEntrega: null,
        formaPagamento: null,
        arquivos: [],
        tipoNotaEntrada: null,
        centroCusto: null,
        projeto: null,
        prazoPagamento: null,
        modoPagamento: null,
        mensagensPersonalizadas: [],
        frete: {
          tipoFrete: null,
          observacaoFrete: null,
          prazoEntrega: null,
          totalTransporte: 0,
          ofertaFreteGratis: false,
          valorMinimoFreteGratis: 0,
          totalTransporteConvertido: 0,
        },
        dataNecessidadeEntregaSolicitacao: null,
      },
      produtosCarrinhosId: this.$route.params.id,
      breadcrumbs: [
        {
          text: 'Carrinho',
          to: '/carrinho',
        },
        {
          text: 'Finalização',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('entidade', ['idEntidade', 'erpCamposIntegracao', 'isAprovacaoEnabled']),
    moeda() {
      // Se chegamos até, assumimos que todos os produtos tem a mesma moeda
      return this.carrinhos[0].respostaCotacao.moeda;
    },
    isAVista() {
      return this.finalizacao.formaPagamento !== FormaPagamento.keys.A_PRAZO.key;
    },
    isCif() {
      return this.finalizacao.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    smModoPagamento() {
      return this.hasDataNecessidadeEntregaSolicitacao ? '3' : '6';
    },
    isModoPagamentoRequired() {
      return isFieldRequiredEntity('modoPagamento', this.camposObrigatorios);
    },
    isCentroCustoRequired() {
      return isFieldRequiredEntity('centroCusto', this.camposObrigatorios);
    },
    isTipoNotaEntradaRequired() {
      return isFieldRequiredEntity('tipoNotaEntrada', this.camposObrigatorios);
    },
    isTransportadoraRequired() {
      return isFieldRequiredEntity('transportadora', this.camposObrigatorios);
    },
    isProjetoRequired() {
      return isFieldRequiredEntity('projeto', this.camposObrigatorios);
    },
    isCentroCustoReadonly() {
      return isFieldReadonlyEntity('centroCusto', this.camposReadonly) && this.hasAnyItemFromRequisicao;
    },
    isProjetoReadonly() {
      return isFieldReadonlyEntity('projeto', this.camposReadonly) && this.hasAnyItemFromRequisicao;
    },
    hasFields() {
      return this.cadastrosAdicionais && Object.keys(this.cadastrosAdicionais).length > 0;
    },
    totaisSaving() {
      return calcularSavingFinalizacao(this.produtos, this.taxaVenda);
    },
    totaisTransporte() {
      return calcularTotaisTransporte(this.finalizacao, this.taxaVenda);
    },
    totaisCompra() {
      return calcularTotaisCompra(this.finalizacao, this.produtos, this.taxaVenda);
    },
    casaDecimal() {
      const mappedProdutos = this.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    showNotificaFornecedor() {
      if (!this.camposPersonalizados || !this.camposPersonalizados?.notificaFornecedor) {
        return true;
      }
      return this.camposPersonalizados.notificaFornecedor.visivel;
    },
    hasAnyItemFromRequisicao() {
      return this.produtos.some(produto => !!produto.requisicaoProduto.id);
    },
    hasDataNecessidadeEntregaSolicitacao() {
      return !!this.finalizacao.dataNecessidadeEntregaSolicitacao;
    },
  },
  methods: {
    ...mapActions('carrinho', {
      getItens: GET_ITENS,
    }),
    onRemoveMessage(item) {
      this.finalizacao.mensagensPersonalizadas = this.finalizacao
        .mensagensPersonalizadas.filter(mensagem => mensagem.id !== item.id);
    },
    onChangeTipoFrete() {
      const [carrinho] = this.carrinhos;
      this.setTransportador(carrinho);
    },
    getDetalhesFornecedor(id) {
      return GestaoFornecedorService.getByFornecedor(id)
        .then(({ data }) => {
          this.cadastrosAdicionais = initialStateCamposErp(this.erpCamposIntegracao);
          this.cadastrosAdicionais = computeFrom(this.erpCamposIntegracao,
            data.cadastrosAdicionais);
        });
    },
    getTipoNotaEntrada() {
      return TipoNotaEntradaService.getNotaEntradaDefault()
        .then((response) => {
          this.finalizacao.tipoNotaEntrada = response.data || null;
        });
    },
    init() {
      this.idsProdutos = this.produtosCarrinhosId.split(',')
        .map(Number);
      this.loading = true;
      CarrinhoService.getItensCarrinho({
        query: `idProduto in (${this.produtosCarrinhosId})`,
      })
        .then((response) => {
          this.carrinhos = this.filterProdutosSelecionados(response.data);
          this.checkSolicitaFormaPagamento();
          this.checkSolicitaFrete();
          this.createProdutos();

          const [carrinho] = this.carrinhos;
          this.setupFinalizacao(carrinho);
          return Promise.all([
            this.getDetalhesFornecedor(carrinho.respostaCotacao.fornecedor.id),
            this.getTipoNotaEntrada(),
            this.getTaxaVendaMoeda(carrinho.respostaCotacao.moeda),
          ]);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterProdutosSelecionados(carrinhos) {
      return carrinhos.map(carrinho => ({
        ...carrinho,
        produtos: carrinho.produtos.filter(produto => this.idsProdutos.includes(produto.id)),
      }));
    },
    setupFinalizacao(carrinho) {
      const { cotacao } = carrinho.respostaCotacao;
      this.setProjeto(cotacao);
      this.setArquivos(cotacao);
      this.setCompradores(cotacao);
      this.setCentroCusto(cotacao);
      this.setObservacaoInterna(cotacao);
      this.setTransportador(carrinho);
      this.setDataPrevisaoEntrega(carrinho);
      this.setDataNecessidadeEntregaSolicitacao(carrinho);
    },
    setArquivos(cotacao) {
      this.finalizacao.arquivos = [...cotacao.arquivos];
    },
    setCompradores(cotacao) {
      this.finalizacao.comprador = cotacao.comprador;
      this.finalizacao.locaisEntrega = cotacao.locaisEntrega;
    },
    setDataPrevisaoEntrega(carrinho) {
      this.finalizacao.dataPrevisaoEntrega = this.getPrevisaoEntrega(carrinho);
    },
    setObservacaoInterna(cotacao) {
      this.finalizacao.observacao = cotacao.observacaoInterna;
    },
    getPrevisaoEntrega(carrinho) {
      const { cotacao } = carrinho.respostaCotacao;
      const previsaoEntrega = carrinho.dataNecessidadeEntregaSolicitacao || cotacao.prazoEntrega;
      return getValidDate(previsaoEntrega);
    },
    setDataNecessidadeEntregaSolicitacao(carrinho) {
      const { dataNecessidadeEntregaSolicitacao } = carrinho;
      this.finalizacao.dataNecessidadeEntregaSolicitacao = dataNecessidadeEntregaSolicitacao;
    },
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
    buildQuantidades() {
      // apenas por segurança, mas já devemos ter somente os produtos selecionados
      const produtos = this.produtos
        .filter(produto => this.idsProdutos.includes(produto.id));
      return produtos.map(p => ({
        carrinhoCotacaoProduto: {
          id: p.id,
        },
        quantidade: p.quantidade,
        tipoNotaEntrada: p.tipoNotaEntrada || null,
        centroCusto: p.centroCusto || null,
        projeto: p.projeto || null,
        especificacaoProduto: p.especificacaoProduto,
        observacaoExterna: p.observacaoExterna,
        cadastrosAdicionais: this.buildCadastrosAdicionaisProdutoPayload(p.cadastrosAdicionais),
        finalidadeCompra: p.finalidadeCompra,
        dataFaturamento: p.dataFaturamento,
        dataPrevisaoEntrega: p.dataPrevisaoEntrega,
      }));
    },
    setProjeto(cotacao) {
      this.finalizacao.projeto = cotacao.projeto;
    },
    getProjetoFromProduto(produto, oldProjeto, newProjeto) {
      const oldProjetoId = oldProjeto ? oldProjeto.id : null;
      if (!produto.projeto || produto.projeto?.id === oldProjetoId) {
        return newProjeto;
      }
      return produto.projeto;
    },
    setProjetoProdutos(newProjeto, oldProjeto) {
      this.produtos = this.produtos.map(produto => ({
        ...produto,
        projeto: this.getProjetoFromProduto(produto, oldProjeto, newProjeto),
      }));
    },
    setCentroCusto(cotacao) {
      this.finalizacao.centroCusto = cotacao.centroCusto;
    },
    getCentroCustoFromProduto(produto, oldCentroCusto, newCentroCusto) {
      const oldCentroCustoId = oldCentroCusto ? oldCentroCusto.id : null;
      if (!produto.centroCusto || produto.centroCusto?.id === oldCentroCustoId) {
        return newCentroCusto;
      }
      return produto.centroCusto;
    },
    setCentroCustoProdutos(newCentroCusto, oldCentroCusto) {
      this.produtos = this.produtos.map(produto => ({
        ...produto,
        centroCusto: this.getCentroCustoFromProduto(produto, oldCentroCusto, newCentroCusto),
      }));
    },
    getNotaEntradaFromProduto(produto, oldNotaEntrada, newNotaEntrada) {
      const oldNotaEntradaId = oldNotaEntrada ? oldNotaEntrada.id : null;
      if (!produto.tipoNotaEntrada || produto.tipoNotaEntrada?.id === oldNotaEntradaId) {
        return newNotaEntrada;
      }
      return produto.tipoNotaEntrada;
    },
    setNotaEntradaProdutos(newNotaEntrada, oldNotaEntrada) {
      this.produtos = this.produtos.map(produto => ({
        ...produto,
        tipoNotaEntrada: this.getNotaEntradaFromProduto(produto, oldNotaEntrada, newNotaEntrada),
      }));
    },
    setTransportador(carrinho) {
      const { fornecedor, cotacao } = carrinho.respostaCotacao;
      if (!this.finalizacao.transportadora && this.isCif) {
        this.finalizacao.transportadora = this.getTransportadora(fornecedor, cotacao);
      }
    },
    getTransportadora(fornecedor, cotacao) {
      return buildFornecedor(cotacao, fornecedor);
    },
    buildCadastrosAdicionaisProdutoPayload(cadastrosAdicionaisProduto) {
      if (!cadastrosAdicionaisProduto) {
        return [];
      }
      return buildCadastrosAdicionaisPayload(
        cadastrosAdicionaisProduto,
        TiposEntidadeCadastroAdicional.keys.COMPRA_PRODUTO.key,
      );
    },
    buildCadastrosAdicionaisPayload() {
      if (!this.cadastrosAdicionais) {
        return [];
      }
      return buildCadastrosAdicionaisPayload(
        this.cadastrosAdicionais,
        TiposEntidadeCadastroAdicional.keys.COMPRA.key,
      );
    },
    buildFrete(frete) {
      return {
        ...frete,
        totalTransporte: frete.totalTransporte ? frete.totalTransporte : 0,
      };
    },
    buildFinalizacao() {
      const finalizacao = { ...this.finalizacao };
      finalizacao.carrinhos = this.carrinhos;
      finalizacao.quantidades = this.buildQuantidades();
      finalizacao.cadastrosAdicionais = this.buildCadastrosAdicionaisPayload();
      finalizacao.frete = this.buildFrete(finalizacao.frete);
      return finalizacao;
    },
    mapProdutos(produto) {
      const {
        cotacaoProduto,
        precoUnitario,
        arquivos,
        saving,
        impostos,
        valorMoedaConvertido,
      } = produto.respostaCotacaoProduto;

      const dataPrevisaoEntrega = getValidDate(
        cotacaoProduto.dataPrevisaoEntrega,
        this.finalizacao.dataPrevisaoEntrega,
      );

      return {
        id: produto.id,
        produto: cotacaoProduto.produto,
        precoUnitario,
        especificacaoProduto: cotacaoProduto.especificacaoProduto,
        observacaoExterna: cotacaoProduto.observacaoExterna,
        quantidade: cotacaoProduto.quantidade,
        tipoNotaEntrada: this.finalizacao.tipoNotaEntrada || null,
        centroCusto: cotacaoProduto.centroCusto
          ? cotacaoProduto.centroCusto : this.finalizacao.centroCusto,
        projeto: cotacaoProduto.projeto ? cotacaoProduto.projeto : this.finalizacao.projeto,
        unidadeMedida: cotacaoProduto.unidadeMedida,
        cadastrosAdicionais: this.mapCadastrosAdicionaisProdutos(cotacaoProduto),
        arquivosFornecedor: arquivos,
        arquivosComprador: cotacaoProduto.arquivos,
        $$quantidadeOriginal: cotacaoProduto.quantidade,
        finalidadeCompra: cotacaoProduto.finalidadeCompra,
        dataFaturamento: this.finalizacao.dataFaturamento,
        requisicaoProduto: {
          id: cotacaoProduto.requisicaoProduto?.id || null,
        },
        saving,
        impostos,
        dataPrevisaoEntrega,
        valorMoedaConvertido,
      };
    },
    getCadastrosAdicionais(cotacaoProduto) {
      const { produto, requisicaoProduto, cadastrosAdicionais } = cotacaoProduto;
      const cadastrosProduto = produto.cadastrosAdicionais || [];
      const cadastrosRequisicao = mergeCadastrosAdicionais(
        cadastrosAdicionais,
        requisicaoProduto?.cadastrosAdicionais || [],
      );

      return mergeCadastrosAdicionais(cadastrosRequisicao, cadastrosProduto);
    },
    mapCadastrosAdicionaisProdutos(cotacaoProduto) {
      const cadastrosAdicionais = this.getCadastrosAdicionais(cotacaoProduto);
      if (!this.erpCamposIntegracao || (!cadastrosAdicionais && !cadastrosAdicionais.length)) {
        return null;
      }
      return computeFromProduto(this.erpCamposIntegracao, cadastrosAdicionais);
    },
    createProdutos() {
      const produtos = flatten(this.carrinhos.map(c => c.produtos));
      this.produtos = produtos.map(this.mapProdutos);
    },
    checkSolicitaFormaPagamento() {
      this.solicitaFormaPagamento = solicitaFormaPagamento(this.carrinhos);
      this.finalizacao.formaPagamento = this.solicitaFormaPagamento.formaPagamento;
      this.finalizacao.prazoPagamento = this.solicitaFormaPagamento.prazoPagamento;
    },
    checkSolicitaFrete() {
      this.finalizacao.frete.totalTransporte = getValorFrete(this.carrinhos);
      this.finalizacao.frete.tipoFrete = getTipoFrete(this.carrinhos);
      this.finalizacao.frete.observacaoFrete = getObservacaoFrete(this.carrinhos);
      this.finalizacao.frete.prazoEntrega = getPrazoEntrega(this.carrinhos);
      this.finalizacao.frete.totalTransporteConvertido = getValorFreteConvertido(this.carrinhos);
    },
    isInvalid() {
      const areProductHeadersInvalid = this.$refs.productHeader
        .some(header => header.validate());

      const areProductContentsInvalid = this.$refs.productContent && this.$refs.productContent
        .some(content => content.validate());

      if (this.validateForm() || areProductHeadersInvalid || areProductContentsInvalid) {
        return true;
      }
      const quantidades = this.produtos.map(p => p.quantidade);
      return some(quantidades, q => !q);
    },
    validateFile() {
      if (this.hasFileLoading) {
        this.$toast('Aguarde até o término do envio dos arquivos', { color: 'error' });
        return true;
      }
      return false;
    },
    validateCadastrosAdicionais() {
      const [isValid, message] = validateCamposErp(this.erpCamposIntegracao,
        this.cadastrosAdicionais);
      if (!isValid) {
        this.$toast(message, { color: 'error' });
      }
      const produtosValidos = this.produtos.map((respostaProduto) => {
        const [isValidProduto, messageProduto] = validateCamposProdutoErp(
          this.erpCamposIntegracao,
          respostaProduto.cadastrosAdicionais,
          respostaProduto.produto,
          null,
          'COMPRA',
        );

        if (!isValidProduto) {
          this.$toast(messageProduto, { color: 'error' });
        }
        return isValidProduto;
      }).every(isValidProduto => isValidProduto);
      return isValid && produtosValidos;
    },
    finalizar() {
      if (this.isInvalid() || this.validateFile() || !this.validateCadastrosAdicionais()) {
        return;
      }
      this.loading = true;
      const finalizacaoCarrinho = this.buildFinalizacao();
      CarrinhoService.finalizar(finalizacaoCarrinho)
        .then(({ data }) => {
          this.getItens();
          this.$toast('Solicitação de confirmação enviada com sucesso', { color: 'success' });

          if (data.tipo === 'APROVACAO') {
            this.$router.push({
              name: 'main.aprovacao-compra.detalhes',
              params: {
                id: data.id,
              },
            });
            return;
          }

          this.$router.push({
            name: 'main.compras.detalhes',
            params: { id: data.id },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickBack() {
      this.$router.push({ name: 'main.carrinho' });
    },
    onChangeFormaPagamento() {
      this.finalizacao.prazoPagamento = null;
    },
    onProductContextInvalid(index) {
      this.expandedPanels.push(index);
    },
    getCamposObrigatorios() {
      EntidadeCamposCompraService.getCamposObrigatorios(this.erpCamposIntegracao)
        .then((data) => {
          this.camposObrigatorios = data;
        });
    },
    getCamposReadonly() {
      EntidadeCamposCompraService.getCamposReadonly(this.erpCamposIntegracao)
        .then((data) => {
          this.camposReadonly = data;
        });
    },
    getCamposHidden() {
      EntidadeCamposCompraService.getCamposHidden(this.erpCamposIntegracao)
        .then((data) => {
          this.camposHidden = data;
        });
    },
    onChangeCheckNotificaFornecedor() {
      this.finalizacao.mensagem = null;
    },
    getDataFaturamentoFromProduto(produto, newData, oldData) {
      if (!produto.dataFaturamento || isSameDate(produto.dataFaturamento, oldData)) {
        return newData;
      }
      return produto.dataFaturamento;
    },
    getDataEntregaFromProduto(produto, newData, oldData) {
      if (!produto.dataPrevisaoEntrega
      || isSameDate(produto.dataPrevisaoEntrega, oldData)
      || !isDateAfterOrSameToday(produto.dataPrevisaoEntrega)) {
        return newData;
      }
      return produto.dataPrevisaoEntrega;
    },
    setDataEntregaProdutos(newData, oldData) {
      this.produtos = this.produtos.map(produto => ({
        ...produto,
        dataPrevisaoEntrega: this.getDataEntregaFromProduto(produto, newData, oldData),
      }));
    },
    setDataFaturamentoProdutos(newData, oldData) {
      this.produtos = this.produtos.map(produto => ({
        ...produto,
        dataFaturamento: this.getDataFaturamentoFromProduto(produto, newData, oldData),
      }));
    },
    onReplicarCampo(campo) {
      if (!campo) {
        return;
      }
      this.produtos = replicarCampoProdutos(this.produtos, campo);
    },
    getCamposPersonalizados() {
      this.loadingCampoPersonalizado = true;
      EntidadeCamposPersonalizadosService.getCamposPersonalizadosCompraById(this.idEntidade)
        .then((campo) => {
          this.camposPersonalizados = campo;
          this.finalizacao = setCamposPersonalizados(this.finalizacao, this.camposPersonalizados);
        })
        .finally(() => {
          this.loadingCampoPersonalizado = false;
        });
    },
    getTaxaVendaMoeda(moeda) {
      MoedaService.getTaxaVendaMoeda(moeda)
        .then(({ data }) => {
          this.taxaVenda = data.taxaVenda;
        });
    },
  },
  created() {
    this.init();
    this.getCamposHidden();
    this.getCamposReadonly();
    this.getCamposObrigatorios();
    this.getCamposPersonalizados();
  },
  validations: {
    finalizacao: {
      formaPagamento: {
        required,
      },
      frete: {
        tipoFrete: {
          required,
        },
      },
      prazoPagamento: {
        // eslint-disable-next-line func-names
        required: requiredIf(function () {
          return !this.isAVista;
        }),
      },
      modoPagamento: {
        required: requiredIf(function () {
          return this.isModoPagamentoRequired;
        }),
      },
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
      tipoNotaEntrada: {
        required: requiredIf(function () {
          return this.isTipoNotaEntradaRequired;
        }),
      },
      transportadora: {
        required: requiredIf(function () {
          return this.isTransportadoraRequired;
        }),
      },
      projeto: {
        required: requiredIf(function () {
          return this.isProjetoRequired;
        }),
      },
      comprador: {
        required,
      },
      locaisEntrega: {
        required,
      },
      dataPrevisaoEntrega: {
        required,
        isDateAfterOrSameToday,
      },
      dataFaturamento: {
        required,
        isDateAfterOrSameToday,
      },
    },
  },
  components: {
    pxFinalizacaoProdutoPanelHeader: FinalizacaoProdutoPanelHeader,
    pxFinalizacaoProdutoPanelContent: FinalizacaoProdutoPanelContent,
    pxFinalizacaoCadastroMensagensPersonalizadas: FinalizacaoCadastroMensagensPersonalizadas,
  },
  watch: {
    'finalizacao.tipoNotaEntrada': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        this.setNotaEntradaProdutos(newVal, oldVal);
      },
    },
    'finalizacao.centroCusto': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        this.setCentroCustoProdutos(newVal, oldVal);
      },
    },
    'finalizacao.projeto': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        this.setProjetoProdutos(newVal, oldVal);
      },
    },
    'finalizacao.dataFaturamento': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        this.setDataFaturamentoProdutos(newVal, oldVal);
      },
    },
    'finalizacao.dataPrevisaoEntrega': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        this.setDataEntregaProdutos(newVal, oldVal);
      },
    },
  },
};
</script>
